const MainPoligon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="751"
      height="878"
      viewBox="0 0 751 878"
      fill="none"
    >
      <path
        d="M-77.5914 20.3265C-74.6552 6.18566 -58.1578 -0.27656 -46.3983 8.10774L738.32 567.597C751.993 577.345 748.292 598.584 732.128 603.133L-224.673 872.408C-239.115 876.472 -252.723 863.779 -249.673 849.09L-77.5914 20.3265Z"
        stroke="#310F21"
        stroke-width="8"
      />
    </svg>
  );
};

export default MainPoligon;
